// sections/ValuePropositionSection.tsx
import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { DollarSign, Clock, Shield } from "lucide-react";

// Import images
import saveMoneyImage from "./images/save-money.webp";
import saveTimeImage from "./images/save-time.jpg";
import peaceOfMindImage from "./images/peace-of-mind.png";

const ValuePropositionSection: React.FC = () => {
  const valueCards = [
    {
      icon: DollarSign,
      title: "Save Money",
      image: saveMoneyImage,
      items: [
        "Compare multiple contingent quotes",
        "No hidden fees or surprise costs",
        "Get upfront pricing before commitments",
        "Make informed financial decisions",
      ],
    },
    {
      icon: Clock,
      title: "Save Weeks of Time",
      image: saveTimeImage,
      items: [
        "No more endless contractor meetings",
        "Get quotes in hours, not weeks",
        "Skip the exhaustive search process",
        "Start projects faster than ever",
      ],
    },
    {
      icon: Shield,
      title: "Peace of Mind",
      image: peaceOfMindImage,
      items: [
        "All contractors pre-verified",
        "Transparent contingent quotes",
        "On-site inspection guarantees",
        "Backup options if needed",
      ],
    },
  ];

  return (
    <section className="py-5 bg-light">
      <Container>
        <h2 className="fs-1 fw-bold text-center mb-5">Why Choose BidBro?</h2>
        <Row className="g-4">
          {valueCards.map((card, index) => (
            <Col key={index} md={4}>
              <Card className="shadow-sm hover-shadow mb-0">
                <div className="position-relative">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="card-img-responsive"
                  />
                  <div className="card-img-overlay">
                    <card.icon className="feature-icon" />
                  </div>
                </div>
                <CardBody className="p-4">
                  <h3 className="fs-5 fw-semibold mb-4">{card.title}</h3>
                  <ul className="list-unstyled text-muted">
                    {card.items.map((item, i) => (
                      <li key={i} className="mb-2">
                        ✓ {item}
                      </li>
                    ))}
                  </ul>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ValuePropositionSection;